module.exports = __webpack_public_path__ + "img/arrow-down-1.5c171824.svg";